import script from "./TasksListHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./TasksListHeader.vue?vue&type=script&setup=true&lang=js"

import "./TasksListHeader.vue?vue&type=style&index=0&id=19d64385&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19d64385"]])

export default __exports__